import firebase from 'utils/firebase';

// TODO create unit test
export const resetPassword = async ({email}, actions) => {
  try {
    await firebase.auth().sendPasswordResetEmail(email);
    actions.setStatus('sent');
  } catch (error) {
    actions.setStatus('failed');
    actions.setSubmitting(false);
    actions.setErrors({email: error.message});
  }
};
